import { Standard } from '@getvim/vim-connect';

export const referralPriority: Standard.Entities.ReferralPriority =
  Standard.Entities.ReferralPriority.ROUTINE;
